import React from "react";
import { Link } from "react-router-dom";
import styles from "./PublicInfoPage.module.scss";

const faqItems = [
	{
		question: "How do I get my login credentials?",
		answer:
			"Please contact your school manager. They are responsible for creating and sharing access credentials.",
		icon: "vpn_key",
	},
	{
		question: "I am unable to log in or facing a technical issue.",
		answer:
			"Please report the issue to your school manager first. They can verify your access and escalate it to Stepswatch support if needed.",
		icon: "support_agent",
	},
	{
		question: "How can I request deletion of my personal data?",
		answer:
			"You can submit a data deletion request by emailing our support team with your school name and registered contact details.",
		icon: "delete_outline",
	},
	{
		question: "Who do I contact for general questions?",
		answer:
			"For general product or account questions, email us and include enough context so we can route the request quickly.",
		icon: "help_outline",
	},
];

const Support = () => {
	return (
		<main className={styles.page}>
			<section className={styles.hero}>
				<div>
					<p className={styles.eyebrow}>Stepswatch</p>
					<h1>Support</h1>
					<p>
						Get help with account access, login issues and general questions
						about using Stepswatch at your school.
					</p>
				</div>
				<Link className={styles.backButton} to="/login">
					<span className="material-icons">arrow_back</span>
					Back to login
				</Link>
			</section>

			<section className={styles.supportLayout}>
				<aside className={styles.supportCard}>
					<div className={styles.supportIcon}>
						<span className="material-icons">mail</span>
					</div>
					<h2>Need assistance?</h2>
					<p>
						Email us with your school name, user role and a short description of
						the issue.
					</p>
					<a className={styles.mailButton} href="mailto:contact@stepswatch.co.in">
						<span className="material-icons">send</span>
						contact@stepswatch.co.in
					</a>
				</aside>

				<div className={styles.faqGrid}>
					{faqItems.map((item) => (
						<article className={styles.faqCard} key={item.question}>
							<span className="material-icons">{item.icon}</span>
							<h2>{item.question}</h2>
							<p>{item.answer}</p>
						</article>
					))}
				</div>
			</section>
		</main>
	);
};

export default Support;
